module.exports = __webpack_public_path__ + "img/daiban.03dd9dcc.png";